import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useParams,
  useNavigate,
} from "react-router-dom";
import { GoChevronLeft } from "react-icons/go";
import { HiArrowNarrowRight } from "react-icons/hi";
import { RiArrowDownSFill, RiFileCopyFill } from "react-icons/ri";
import FileCopyIcon from "@mui/icons-material/FileCopy";
// import { BsLink45Deg, BsFillArrowRightCircleFill, BsInfoCircleFill } from 'react-icons/bs';
import { Grid, Card, CardContent } from "@mui/material";
// import { IoClose } from "react-icons/io5";
import $ from "jquery";

import Config from "../core/config/";
import { makeRequest } from "../core/services/v1/request";

import NavbarOne from "./siteTheme/NavbarOne";
import Footer from "./siteTheme/Footer";

import { toast } from "../core/lib/toastAlert";

// import Depositimage from "../assets/images/deposit/Group.png";
import noreplay from "../assets/images/deposit/no-re.png";

// import ReactTooltip from "react-tooltip";
import { dateFormat, shortAdrress } from "../core/helper/date-format";
import { useContextData } from "../core/context/index";
import { TbUpload } from "react-icons/tb";
import { useFileUpload } from "use-file-upload";
import * as yup from "yup";
import { useFormik } from "formik";
// import Upload from "../assets/images/cloud+upload+file.png";
import DefaultUpload from "../assets/images/cloud+upload+file.png";
import { copyText, pageAllowCheck, clickNavigate } from "../core/helper/common";

// import "../assets/style.css";
import Pagination from "react-responsive-pagination";
import "../pagination.css";

const validationSchema = yup.object({
  amount: yup
    .number()
    .integer("Please enter the valid amount")
    .typeError("Please enter the valid amount")
    .required("Amount is required"),
  // .test(
  //   "maxDigitsAfterDecimal",
  //   "Please enter the valid amount",
  //   (number) => /^\d+(\.\d{1,2})?$/.test(number)
  // )
  transactionNumber: yup
    .string("Please enter the transaction ID")
    // .number()
    // .integer("Please enter the valid Transaction ID")
    // .typeError("Please enter the valid Transaction ID")
    .required("Transaction ID is required"),
  // .test(
  //   "maxDigitsAfterDecimal",
  //   "Please enter the valid Transaction ID",
  //   (number) => /^\d+(\.\d{1,2})?$/.test(number)
  // )
  // myfile1: yup.mixed().required("Attachment is required"),
});

export default function DepositFiat(props) {
  const defaultSrc = DefaultUpload;
  const navigate = useNavigate();
  let { currencySymbol } = useParams();
  const { siteSettings, myProfile, setUserProfile } = useContextData();
  const [files, selectFiles] = useFileUpload();

  const [fiatCurrency, setFiatCurrency] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [depositfiatlist, setdepositfiatList] = useState({});
  const [attachment, setattachment] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);
  const [totalorders, settotalorders] = useState(0);

  // adm
  const [adminAccountDetails, setAdminAccountDetails] = useState([]);
  const [accountDetails, setAccountDetails] = useState({});
  // usr
  const [usrBankList, setUsrBankList] = useState([]);
  const [usrAccountDetails, setUsrAccountDetails] = useState({});

  async function getBankPaymentsDet() {
    try {
      const params = {
        url: `${Config.V2_API_URL}customer/getBankPayments`,
        method: "GET",
      };
      const response = await makeRequest(params);
      if (response.status && response.data) {
        let bankDet = [];
        if (response.data.length > 0) {
          response.data.map((data, i) => {
            if (i == 0 && data.status == 1) {
              setUsrAccountDetails(data);
            }
            if (data.status == 1) {
              bankDet.push(data);
            }
          });
          setUsrBankList(bankDet);
        } else {
          let type = "error";
          toast({ type, message: "Please add bank details" });
          setTimeout(() => navigate("/my/payment"), 500);
        }
      } else {
        let type = "error";
        toast({ type, message: "Please add bank details" });
        setTimeout(() => navigate("/my/payment"), 500);
      }
    } catch (err) { }
  }

  useEffect(() => {
    $(".crypto-workflow-section-close-button").click(function () {
      $(".deposit-second-section").hide();
    });
  }, []);

  useEffect(() => {
    if (currencySymbol) {
      getparticularCurrency_func(currencySymbol);
    }
    getparticularCurrency_func();
    getHistory();
  }, [currencySymbol]);

  useEffect(() => {
    console.log("fiatCurrency", {fiatCurrency});
    if (fiatCurrency && fiatCurrency.currencySymbol) {
      getAdminAccountDetails();
      if(currencySymbol == "INR") {
        getBankPaymentsDet();
      }
    }
  }, [fiatCurrency]);

  useEffect(() => {
    if (myProfile && currencySymbol) {
      const pageAllowCheckResp = pageAllowCheck(
        myProfile,
        "deposit",
        "deposit"
      );
      if (pageAllowCheckResp && pageAllowCheckResp.type == "error") {
        toast({
          type: pageAllowCheckResp.type,
          message: pageAllowCheckResp.message,
        });
        navigate(pageAllowCheckResp.navigate);
      } else {
        // need to check
        const data = { type: "deposit", row: { currencySymbol } };
        clickNavigate(data, myProfile);
      }
    }
  }, [myProfile]);

  async function getparticularCurrency_func(getSym = "") {
    try {
      if(getSym) {
        let payloadData = {
          currencySymbol: getSym.toUpperCase(),
          section: "deposit-request"
        };
        const params = {
          url: `${Config.V1_API_URL}wallet/getParticularCurrency`,
          method: "POST",
          body: payloadData,
        };
        const response = await makeRequest(params);
        if (response.status && response.data) {
          if (response.data.depositEnable === 0) {
            navigate("/my/dashboard");
          }
          else {
            setFiatCurrency(response.data);
          }
        }
        else {
          toast({type: "error", message: "Cssurrency Not found"});
          navigate("/my/wallet");
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  const formik = useFormik({
    initialValues: {
      amount: "",
      transactionNumber: "",
      myfile1: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let response = { status: false };
      const attachmentReq = true;
      if (attachmentReq == true) {
        if (!values.myfile1) {
          toast({ type: "error", message: "Attachment is required" });
        }
        else {
          setisLoading(true);
          const formData = new FormData();
          let sizeFile = 1;
          let fileToUpload = values.myfile1;
          let fileName = "attachment";
          let fileExtension = fileToUpload.name.split("?")[0].split(".").pop();
          formData.append(
            "images[]",
            fileToUpload,
            fileName + "." + fileExtension
          );
          const params = {
            url: `${Config.V1_API_URL}upload/fileUpload?sizeFile=${sizeFile}&&type="attachment"`,
            method: "POST",
            body: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          response = await makeRequest(params);
        }
      } else {
        setisLoading(true);
      }
      if (response.status) {
        const data = {
          currencySymbol,
          amount: values.amount,
          transactionNumber: values.transactionNumber,
          attachment: response.message ? response.message[0].location : "",
          paymentId: accountDetails._id,
          userPaymentId: usrAccountDetails && usrAccountDetails._id ? usrAccountDetails._id : "",
        };
        const params = {
          url: `${Config.V1_API_URL}wallet/depositFiat`,
          method: "POST",
          body: data,
        };
        const result = await makeRequest(params);
        let type = "error";
        if (result.status) {
          type = "success";
          toast({ type, message: result.message });
          formik.resetForm();
          formik.values.myfile1 = "";
          setattachment("");
          getHistory();
          setUserProfile();
          setisLoading(false);
        } else {
          setisLoading(false);
          type = "error";
          const errmsg = result.message.split(" ");
          if (errmsg[0] == "KYC") {
            navigate("/my/identification");
          } else if (errmsg[0] == "Bank") {
            navigate("/my/payment");
          }
          setisLoading(false);
          toast({ type, message: result.message });
        }
      }
      setisLoading(false);
    },
  });

  async function getAdminAccountDetails() {
    try {
      const params = {
        url: `${Config.V1_API_URL}payment/adminBank/list?currencySymbol=${currencySymbol}`,
        method: "GET",
      };
      const response = await makeRequest(params);
      if (response.status) {
        response.message.length > 0 &&
          response.message.map((item, i) => {
            if (i === 0) {
              setAccountDetails(item);
            }
          });
        setAdminAccountDetails(response.message);
      }
    } catch (err) { }
  }

  async function getHistory() {
    try {
      const value = { type: "Deposit", currencyType: "Fiat" };
      const params = {
        url: `${Config.V1_API_URL}wallet/getHistory`,
        method: "POST",
        body: value,
      };
      const response = await makeRequest(params);
      if (response.status) {
        setdepositfiatList(response.data);
        settotalorders(response.total);
      }
    } catch (err) { }
  }

  const noOfPages = Math.ceil(totalorders / recordsPerPage);

  const clickPageNo = (pgNumber) => {
    pageChange(pgNumber);
  };
  const pageChange = (newCurrentPage) => {
    if (newCurrentPage >= 1 && newCurrentPage <= noOfPages) {
      setCurrentPage(newCurrentPage);
      getPagination(newCurrentPage);
    }
  };
  async function getPagination(page) {
    try {
      const data = {
        type: "Deposit",
        currencyType: "Fiat",
        limit: recordsPerPage,
        offset: recordsPerPage * (page - 1),
      };
      const params = {
        url: `${Config.V1_API_URL}wallet/getHistory`,
        method: "POST",
        body: data,
      };
      const response = await makeRequest(params);
      if (response.status && response.data) {
        setdepositfiatList(response.data);
        settotalorders(response.total);
      }
    } catch (err) { }
  }
  async function handleBankChange(type) {
    setAccountDetails(type);
  }
  async function handleUsrBankChange(type) {
    setUsrAccountDetails(type);
  }
  async function copyToCode(textToCopy, message = "") {
    try {
      var input = document.createElement("textarea");
      document.body.appendChild(input);
      input.value = textToCopy;
      input.select();
      document.execCommand("Copy");
      input.remove();
      toast({ type: "success", message });
    } catch (err) { }
  }
  return (
    <div>
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />
      <div className="deposit-page-top-banner">
        <div className="deposit-hero-section">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-6" onClick={() => navigate("/my/dashboard")}>
                <GoChevronLeft className="deposit-back-button-icon" />
                <span className="deposit-text-1">Deposit Request</span>
              </div>
              <div
                className="col-6 text-end"
                onClick={() => {
                  navigate(
                    "/deposit/crypto"
                  )
                }
                }
              >
                <button type="button" className="deposit-fiat-button">
                  Deposit Crypto <HiArrowNarrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row gap-2 justify-content-center background-color-deposit px-4 pb-5 my-4">
            <div className="col-lg-5">
              <form onSubmit={formik.handleSubmit}>
                <div className="">
                  <div className="mt-5">
                    <div className="">
                      <div className="withdraw-nav-tabs">
                        {currencySymbol && currencySymbol != "INR" && accountDetails && accountDetails.paymenttype && (
                        <div className="mb-4">
                          <p className="deposit-text-33 mb-2">
                            Select {Config.SITENAME} Account
                          </p>
                          <div
                            className="d-flex flex-row align-items-center deposit-select-coin-section"
                            data-bs-toggle="modal"
                            data-bs-target="#selectModalAdmAcct"
                          >
                            <span className="deposit-text-4">
                              {accountDetails.paymenttype.toUpperCase()}-
                              {
                                accountDetails.paymenttype === "bank" ?
                                  accountDetails.accountNumber
                                :
                                  accountDetails.paymenttype === "upi" ?
                                    accountDetails.upiID
                                  :
                                  accountDetails.paymenttype === "crypto" ?
                                    accountDetails.accountNumber &&
                                    accountDetails.accountNumber.slice(0, 5) + "..." + accountDetails.accountNumber.slice(-5)
                                  :
                                    "-"
                                }
                            </span>
                            <div className="ms-auto">
                              <RiArrowDownSFill />
                            </div>
                          </div>
                        </div>)}

                        {currencySymbol && currencySymbol == "INR" && (
                          <>
                            <div>
                              <p className="deposit-text-33 mb-2">
                                Select {Config.SITENAME} Account
                              </p>
                              <div className="row justify-content-start gap-1 py-2">
                                {adminAccountDetails.length > 0 &&
                                  adminAccountDetails.map((row, i) => {
                                    return (
                                      <div className="col-4 col-md-3 col-lg-4 col-xl-3" key={i} onClick={() => handleBankChange(row)}>
                                        <div className="d-flex flex-column gap-1 align-items-center">
                                          <img src={row.image} alt="Bank images" width={34} height={34} className={"img-fluid "+ (accountDetails && accountDetails.bankName == row.bankName ? "outline-active" : "")} />
                                          <p>{row.bankName}</p>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                            <div className="mb-4">
                              <p className="deposit-text-33 mb-2">
                                Select Account
                              </p>
                              <div
                                className="d-flex flex-row align-items-center deposit-select-coin-section"
                                data-bs-toggle="modal"
                                data-bs-target="#selectModalUsrAcct"
                              >
                                <div className="">
                                  <span className="deposit-text-4">
                                    {usrAccountDetails.paymenttype ? usrAccountDetails.paymenttype.toUpperCase() : ""}
                                    {usrAccountDetails.paymenttype
                                      ? usrAccountDetails.paymenttype.toLowerCase() ===
                                        "bank"
                                        ? usrAccountDetails.accountNo
                                        : usrAccountDetails.paymenttype.toLowerCase() ===
                                          "upi"
                                          ? usrAccountDetails.upiId
                                          : ""
                                      : ""}
                                  </span>
                                </div>
                                <div className="ms-auto">
                                  <RiArrowDownSFill />
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="mb-4">
                          <p className="deposit-text-33 mb-2">Amount</p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Amount"
                            id="amount"
                            name="amount"
                            autoComplete="off"
                            value={formik.values.amount}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.amount &&
                              Boolean(formik.errors.amount)
                            }
                            helperText={
                              formik.touched.amount && formik.errors.amount
                            }
                          />
                          {formik.errors.amount ? (
                            <small className="invalid-amount error">
                              {formik.errors.amount}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-4">
                          <p className="deposit-text-33 mb-2">Transaction ID</p>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Transaction ID"
                            id="transactionNumber"
                            name="transactionNumber"
                            autoComplete="off"
                            value={formik.values.transactionNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.transactionNumber &&
                              Boolean(formik.errors.transactionNumber)
                            }
                            helperText={
                              formik.touched.transactionNumber &&
                              formik.errors.transactionNumber
                            }
                          />
                          {formik.errors.transactionNumber ? (
                            <small className="invalid-transactionNumber error">
                              {formik.errors.transactionNumber}
                            </small>
                          ) : null}
                        </div>
                        <div>
                          <img
                            className="payment-qrcode-optional-image"
                            src={files?.source || defaultSrc}
                            alt="preview"
                          />
                          <br />
                          <button
                            className="payment-qrcode-optional-button mt-3"
                            name="myfile1"
                            onClick={() =>
                              selectFiles(
                                { accept: "image/*" },
                                ({ name, size, source, file }) => {
                                  console.log("Files Selected", {
                                    name,
                                    size,
                                    source,
                                    file,
                                  });
                                  setattachment(file);
                                  formik.values.myfile1 = file;
                                  formik.errors.myfile1 = "";
                                }
                              )
                            }
                          >
                            <TbUpload />
                            Upload
                          </button>
                        </div>
                        {formik.errors.myfile1 ? (
                          <small className="invalid-myfile1 error">
                            {formik.errors.myfile1}
                          </small>
                        ) : null}
                        <button
                          type="submit"
                          disabled={isLoading}
                          className="btn text-white btn-col w-100 mt-4"
                        >
                          Submit Deposit Request
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-6 align-self-center">
              <Grid item xs={12} sm={6} className="text-left-move">
                <div className="d-flex flex-column gap-3">
                  <h2 className="color-yellow font-bold fs-4">
                    Send Money to this account
                  </h2>
                </div>
                {fiatCurrency && accountDetails && (
                  <div className="py-4">
                    {accountDetails.paymenttype === "bank" && (
                      <div className="bg-white-card ">
                        <div className="d-flex flex-column gap-2">
                          <p className="d-flex justify-content-between">
                            <b>Minimum Deposit Amount: </b>
                            {fiatCurrency.minCurDeposit}{" "}{fiatCurrency.currencySymbol}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Bank Name: </b>
                            {accountDetails.bankName}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Account Name: </b>
                            {accountDetails.accountName}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Account Number: </b>
                            <p>
                              {accountDetails.accountNumber}{" "}
                              <RiFileCopyFill
                                onClick={() =>
                                  copyToCode(
                                    accountDetails.accountNumber,
                                    "Account Number copied successfully."
                                  )
                                }
                              />
                            </p>
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Swift / IFSC Code: </b>
                            <p>
                              {accountDetails.swiftIFSCCode}{" "}
                              <RiFileCopyFill
                                onClick={() =>
                                  copyToCode(
                                    accountDetails.swiftIFSCCode,
                                    "Swift / IFSC Code copied successfully."
                                  )
                                }
                              />
                            </p>
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>City: </b>
                            {accountDetails.city}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Account Type: </b>
                            {accountDetails.accountType}
                          </p>
                        </div>
                      </div>
                    )}
                    {accountDetails.paymenttype === "upi" && (
                      <div>
                        <div className="d-flex flex-column gap-2">
                          <p className="d-flex justify-content-between">
                            <b>Minimum Deposit Amount: </b>
                            {fiatCurrency.minCurDeposit}{" "}{fiatCurrency.currencySymbol}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>UPI Code: </b>
                            <p>
                              {accountDetails.upiID}{" "}
                              <RiFileCopyFill
                                onClick={() =>
                                  copyToCode(
                                    accountDetails.upiID,
                                    "UPI ID copied successfully."
                                  )
                                }
                              />
                            </p>
                          </p>
                          {accountDetails.image && (
                          <p className="d-flex justify-content-between">
                            <b>QR Code: </b>
                            <p>
                              <img
                                src={accountDetails?.image}
                                alt="attachImg"
                                className="withdraw-UPI-QR d-block"
                              />
                            </p>
                          </p>
                          )}
                        </div>
                      </div>
                    )}
                    {accountDetails.paymenttype === "crypto" && (
                      <div>
                        <div className="d-flex flex-column gap-2">
                          <p className="d-flex justify-content-between">
                            <b>Minimum Deposit Amount: </b>
                            {fiatCurrency.minCurDeposit}{" "}{fiatCurrency.currencySymbol}
                          </p>
                          <p className="d-flex justify-content-between">
                            <b>Network: </b>
                            {accountDetails.accountType}
                          </p>
                          <p className="d-flex justify-content-between">
                            <div>
                              <b>Address: </b>
                            </div>
                            <div className="d-flex justify-content-end align-items-center gap-2">
                              <p className="col-8 word-break">
                                {accountDetails.accountNumber}{" "} </p>
                                <RiFileCopyFill
                                  onClick={() =>
                                    copyToCode(
                                      accountDetails.accountNumber,
                                      "Address copied successfully."
                                    )
                                  }
                                />
                            </div>
                          </p>
                          {accountDetails.image && (
                          <p className="d-flex justify-content-between">
                            <b>QR Code: </b>
                            <p>
                              <img
                                src={accountDetails?.image}
                                alt="attachImg"
                                className="withdraw-UPI-QR d-block"
                              />
                            </p>
                          </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {
                  currencySymbol ?
                <div>
                  <h3>Important Notice</h3>
                   {fiatCurrency && fiatCurrency.basecoin == "Manual" ?
                  <p>{currencySymbol} Deposit is now a manual process and kindly follow the below steps</p>
                  : ""}
                  <div className="mt-2">
                    <ul className="mt-12 list-unstyled d-flex flex-column gap-2">
                      {currencySymbol == "INR" ? (<>
                      <li className="password-text-33 list-unstyled">
                        1: IMPS, NEFT & RTGS are allowed for this account
                      </li>
                      <li className="password-text-33 list-unstyled">
                        2: UPI Apps like gPay, PhonePe, Paytm are not available.
                      </li>
                      <li className="password-text-33 list-unstyled">
                        3: INR Deposit and Withdrawal take upto 24 hours to Process
                      </li>
                      </>): fiatCurrency && fiatCurrency.basecoin == "Manual" ?
                      <>
                      <li className="password-text-33 list-unstyled">
                        1: Copy the {currencySymbol} Deposit address from {Config.SITENAME}
                      </li>
                      <li className="password-text-33 list-unstyled">
                        2: Make the transfer from your 3rd party wallet to the copied {currencySymbol} Deposit address
                      </li>
                      <li className="password-text-33 list-unstyled">
                        3: Copy of the transaction id after the completion of the transaction and Submit the Transaction ID, Amount and Submit deposit request.
                      </li>
                      </>
                      :""}
                      {fiatCurrency.depositNotes ? (
                        <li className="password-text-33 list-unstyled">
                          4: {fiatCurrency.depositNotes}
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>:""}

                
              </Grid>
            </div>
          </div>
        </div>

        <div className="container deposit-fourth-section mt-4">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <h1 className="deposit-text-11">Recent Deposits</h1>
              <table className="table mt-4">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Type</th>
                    <th>Asset</th>
                    <th>Amount</th>
                    {/* <th>Destination</th> */}
                    <th>Transaction ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {depositfiatlist?.length > 0 &&
                    depositfiatlist.map((row, i) => (
                      <tr key={i}>
                        <td
                          data-label="Time"
                          className="color-white color-borders"
                        >
                          {dateFormat(row.createdDate)}
                        </td>
                        <td
                          data-label="Type"
                          className="color-white color-borders"
                        >
                          {row.type}
                        </td>
                        <td
                          data-label="Asset"
                          className="color-white color-borders"
                        >
                          <span className="tb-img">
                            <img
                              src={row.currencyId.image}
                              alt={Config.SITENAME}
                              style={{ width: "20px", height: "20px" }}
                              className="img-fluid img-res"
                            />{" "}
                          </span>
                          &nbsp;{row.currencyId.currencySymbol}
                        </td>
                        <td
                          data-label="Amount"
                          className="color-white color-borders"
                        >
                          {row.amount}
                        </td>
                        <td
                          data-label="TxID"
                          className="color-white color-borders cursor"
                        >
                          {shortAdrress(row.txnId != "" ? row.txnId : "-")}
                        </td>
                        <td
                          data-label="Status"
                          className="color-white color-borders"
                        >
                          {row.status == 0
                            ? "Pending"
                            : row.status == 1
                              ? "Approved"
                              : row.status == 2
                                ? "Rejected"
                                : "Processing"}
                        </td>
                      </tr>
                    ))}
                  {depositfiatlist?.length == 0 && (
                    <tr className="no-records-found">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        <img
                          className="no-record-image"
                          src={noreplay}
                          alt="no-record"
                        />
                        <br />
                        <span className="text-center">No Records Found</span>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
              {totalorders > recordsPerPage && (
                <div className="row">
                  <div className="col-lg-12 d-flex justify-content-end">
                    <Pagination
                      className="p2p-trade-pagination"
                      total={Math.ceil(totalorders / recordsPerPage)}
                      current={currentPage}
                      onPageChange={(page) => clickPageNo(page)}
                    />
                  </div>
                </div>
              )}
              {/* { depositfiatlist?.length > 0 &&
                <div className="d-flex flex-row mt-4 mb-5">
                  <div className="mx-auto">
                    <button type="button" className="table-view-all-deposit-button-1">
                      View More{" "}
                      <BsFillArrowRightCircleFill className="view-more-icon" />
                    </button>
                    <button type="button" className="table-view-all-deposit-button-2">
                      View Less{" "}
                      <BsFillArrowRightCircleFill className="view-more-icon" />
                    </button>
                  </div>
                </div>
              } */}
            </div>
          </div>
        </div>

        <div
          className="modal fade withdraw-crypto-modal"
          id="selectModalAdmAcct"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header ">
                <h4 className="modal-title" id="exampleModalLabel">
                  Select {Config.SITENAME} Account
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body modal-2-overflow-scroll">
                <ul className="withdraw-crypto-modal-list">
                  {adminAccountDetails.length > 0 &&
                    adminAccountDetails.map((row, i) => {
                      return (
                        <li key={i} onClick={() => handleBankChange(row)}>
                          <a data-bs-dismiss="modal">
                            <div className="d-flex flex-row align-items-center withdraw-crypto-list-items">
                              <div className="">
                                <span className="withdraw-crypto-modal-text-1">
                                  {row.paymenttype.toUpperCase()}-{row.accountNumber ? row.accountNumber.slice(0, 5) + "..." + row.accountNumber.slice(-5) : row.upiID ? row.upiID : ""}
                                </span>
                              </div>
                            </div>
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade withdraw-crypto-modal"
          id="selectModalUsrAcct"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header ">
                <h4 className="modal-title" id="exampleModalLabel">
                  Select Payment Account
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body modal-2-overflow-scroll">
                <ul className="withdraw-crypto-modal-list">
                  {usrBankList.length > 0 &&
                    usrBankList.map((row, i) => {
                      if (row && row.paymenttype) {
                        return (
                          <li key={i} onClick={() => handleUsrBankChange(row)}>
                            <a data-bs-dismiss="modal">
                              <div className="d-flex flex-row align-items-center withdraw-crypto-list-items">
                                <div className="">
                                  {row.paymenttype.toLowerCase() === "bank" ? (
                                    <span className="withdraw-crypto-modal-text-1">
                                      {row.paymenttype.toUpperCase() +
                                        "-" +
                                        row.accountNo}
                                    </span>
                                  ) : row.paymenttype.toLowerCase() ===
                                    "upi" ? (
                                    <span className="withdraw-crypto-modal-text-1">
                                      {row.paymenttype.toUpperCase() +
                                        "-" +
                                        row.upiId}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </a>
                          </li>
                        );
                      }
                    })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
